module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circ-despe"
  }, [_c('div', {
    staticClass: "cont-cir"
  }, [_c('p', [_c('span', {
    staticClass: "font-red davi-curs"
  }, [_vm._v("¡Felicitaciones! ")]), _c('br'), _vm._v(" Ha terminado el curso"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Administración del Dinero")]), _c('br'), _vm._v(" Continúe aprendiendo en"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "davi-curs font-red"
  }, [_vm._v("MIS FINANZAS EN CASA")]), _c('br'), _vm._v(" El lugar para aprender a manejar las finanzas personales y familiares\n    ")]), _vm._v(" "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-367a2379","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FinalCurso.vue
// module id = 960
// module chunks = 1